<template>
	<div class="flex flex_col environcpage">
		<!-- 上面的选择 -->
		<div class="selects">
			<el-form
				:model="queryParam"
				ref="ruleform"
				:inline="true"
				class="flex flex_ju_sb warnform-inline"
			>
				<div class="form-inputs" :class="{ 'form-inputs-show': isShowAllSelect }">
					<el-form-item
						label="选择生产区域"
						v-if="isShowAllSelect"
						class="form-item-area"
					>
						<el-select
							v-model="allOrgId"
							:placeholder="orgAllSelect.length ? '请选择' : '暂无设备'"
							@change="changeAllOrg"
						>
							<el-option
								v-for="(item, index) in orgAllSelect"
								:key="index"
								:value="item.orgId"
								:label="item.orgName"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item
						:label="isShowAllSelect ? '' : '选择生产区域'"
						:class="{ 'form-item-had': isShowAllSelect }"
					>
						<el-select
							:placeholder="orgSelect.length ? '请选择' : '暂无设备'"
							v-model="queryParam.orgId"
							@change="changeOrg"
						>
							<el-option
								v-for="(item, index) in orgSelect"
								:key="index"
								:value="item.orgId"
								:label="item.orgName"
							></el-option>
						</el-select>
					</el-form-item>

					<!-- 中间参数选择 -->
					<el-form-item
						:label="isShowAllSelect ? '' : '选择传感器'"
						:class="{ 'form-item-had': isShowAllSelect }"
					>
						<el-select
							:placeholder="codeSelect.length ? '请选择' : '暂无设备'"
							v-model="queryParam.sensorCode"
						>
							<el-option
								v-for="(item, index) in codeSelect"
								:key="index"
								:label="item.deviceName"
								:value="item.serialNumber"
							></el-option>
						</el-select>
					</el-form-item>

					<el-form-item
						label="选择时间"
						class="form-picker"
						:class="{ 'form-item-had': isShowAllSelect }"
					>
						<div class="picker-divs picker-divs-more">
							<el-date-picker
								v-model="queryParam.startTime"
								size="small"
								type="datetime"
								placeholder="选择日期"
								popper-class="pick-poper"
								class="picker-div"
								format="yyyy-MM-dd HH:mm:ss"
								value-format="yyyy-MM-dd HH:mm:ss"
								prefix-icon=" "
								clear-icon="el-icon-date"
								:clearable="false"
								:picker-options="pickerOptions0"
								:editable="false"
							>
							</el-date-picker>
							<i class="pick-icon el-icon-date"></i>
							<i class="pick-icon-yuan el-icon-time"></i>
						</div>

						<span class="pick-word">至</span>
						<div class="picker-divs picker-divs-more">
							<el-date-picker
								v-model="queryParam.endTime"
								size="small"
								type="datetime"
								placeholder="选择日期"
								popper-class="pick-poper"
								class="picker-div"
								format="yyyy-MM-dd HH:mm:ss"
								value-format="yyyy-MM-dd HH:mm:ss"
								prefix-icon=" "
								clear-icon="el-icon-date"
								:clearable="false"
								:picker-options="pickerOptions1"
								:editable="false"
							>
							</el-date-picker>
							<i class="pick-icon el-icon-date"></i>
							<i class="pick-icon-yuan el-icon-time"></i>
						</div>
					</el-form-item>
				</div>

				<el-form-item class="form-btns">
					<el-button type="primary" @click="onSubmit">查询</el-button>
					<!-- <el-button type="primary" @click="onExport">导出</el-button> -->
					<el-button type="primary" @click="exportDownLoad">导出</el-button>
				</el-form-item>
			</el-form>
		</div>
		<!-- 下面的折线图 -->
		<div class="content-all">
			<!-- 综合显示 -->
			<div class="all-wrap">
				<!-- tab切换 -->
				<div class="flex tabs">
					<div
						class="tab-btn"
						:class="{ 'tab-btn-active': tabIndex == 0 }"
						@click="changeTab(0)"
					>
						<img
							class="tab-icon"
							src="@/assets/image/analysis/icon_chart.png"
							alt=""
						/>
						<span>统计图表</span>
					</div>
					<div
						class="tab-btn"
						:class="{ 'tab-btn-active': tabIndex == 1 }"
						@click="changeTab(1)"
					>
						<img
							class="tab-icon"
							src="@/assets/image/analysis/icon_table.png"
							alt=""
						/><span>统计报表</span>
					</div>
				</div>

				<div
					class="flex flex_col chart-content"
					v-loading="loading"
					v-if="tabIndex == 0"
				>
					<template v-if="lengend.length">
						<!-- lengend图例 -->
						<div class="flex flex_a_c lengends">
							<div
								v-for="(item, index) in lengend"
								:key="index"
								class="lengend-div"
							>
								<span
									class="lengend-len"
									:style="{ background: lengendColors[index] }"
								></span>
								<span class="lengend-name">{{ item }}</span>
							</div>
						</div>
						<!-- 统计图表 -->
						<div class="chart-all">
							<div
								class="chart-divs"
								v-for="(item, index) in smallLineData"
								:key="index"
							>
								<!-- 折线图 -->
								<small-chart-modal
									:index="index"
									:datas="item"
									:orgName="orgName"
								></small-chart-modal>
								<div class="icon_setdiv" @click="changeWrap(true, index)">
									<img
										class="icon_add"
										v-show="lengend.length"
										src="@/assets/image/analysis/icon_add.png"
										alt=""
									/>
								</div>
							</div>
						</div>
					</template>
					<div
						class="table-empty flex flex_col flex_ju_c flex_a_c bottom-empty"
						v-else
					>
						<img
							class="table-noimg"
							src="@/assets/image/home/img_none.png"
							alt=""
						/>
						<div class="table-emptyword">暂无数据</div>
					</div>
				</div>
				<!-- 统计报表 -->
				<div class="table-content" v-if="tabIndex == 1">
					<big-table-modal ref="bigTableModal"></big-table-modal>
				</div>
			</div>

			<!-- 单个显示 -->
			<div class="one-wrap" v-if="isShowBig">
				<div class="flex flex_ju_sb one-main" v-show="!bigIsEmpty">
					<!-- 左边的折线图 -->
					<div class="big-chart" ref="bigChart"></div>
					<!-- 右边的table -->
					<div class="warn-tables big-table">
						<div style="text-align: right">
							<div class="icon_setdiv" @click="changeWrap(false)">
								<img
									class="icon_add"
									src="@/assets/image/analysis/icon_sun.png"
									alt=""
								/>
							</div>
						</div>

						<el-table
							:data="bigTableShowData"
							class="tables"
							:stripe="false"
							align="center"
							header-cell-class-name="header-cell"
							cell-class-name="table-cell"
						>
							<el-table-column
								type="index"
								label="序号"
								align="center"
								:width="120"
							>
							</el-table-column>
							<el-table-column
								prop="values"
								:label="bigTableName"
								align="center"
								show-overflow-tooltip
							>
							</el-table-column>
							<el-table-column
								prop="times"
								label="接收时间"
								align="center"
								show-overflow-tooltip
							>
							</el-table-column>
						</el-table>
						<!-- 分页 -->
						<el-pagination
							class="pagination"
							layout="prev, pager, next"
							:current-page.sync="rightPageNum"
							:total="bigTableData.length"
							:pager-count="5"
							:page-size="10"
							:hide-on-single-page="true"
							@current-change="handleCurrentChange"
						>
						</el-pagination>
					</div>
				</div>
				<div class="emptys" v-show="bigIsEmpty">
					<div style="text-align: right">
						<!-- <div class="icon_setdiv" @click="changeWrap(false)">
              <img
                class="icon_add"
                src="@/assets/image/analysis/icon_add.png"
                alt=""
              />
            </div> -->
					</div>
					<div
						class="table-empty flex flex_col flex_ju_c flex_a_c bottom-empty"
					>
						<img
							class="table-noimg"
							src="@/assets/image/home/img_none.png"
							alt=""
						/>
						<div class="table-emptyword">暂无数据</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BigTableModal from './components/environChange/BigTableModal.vue'
import SmallChartModal from './components/environChange/SmallChartModal.vue'
import tableMinin from '@/mixins/TableMinin'
import {
	prevDayTime,
	GetPreMonthDay,
	GetNextMonthDay,
	getFormatDate,
} from '../../times/moment'
/**
 * @description 区域环境变化
 */
export default {
	mixins: [tableMinin],
	components: { BigTableModal, SmallChartModal },
	data() {
		const self = this
		return {
			isMakeTime: false,
			tabIndex: 0, // tab的选中值
			orgSelect: [], // 区域下拉选
			codeSelect: [], // 传感器下拉选
			orgAllSelect: [], // 生产区域下拉选
			allOrgId: '', /// 分公司下面选中的orgid
			loading: true,
			// 表单数据
			queryParam: {
				orgId: '',
				sensorCode: '',
				startTime: '',
				endTime: '',
			},
			lengendColors: [
				'#2DAEA9',
				'#1AA1DF',

				'#8745E9',
				'#0EF0A3',
				'#EE00EB',
				'#2D3CAE',
				'#D76933',
				'#ADE534',
				'#F33D1B',
				'#EAEC1B',
				'#0EF024',
				'#0EECF3',
				'#998AE7',
				'#1560D6',
			],
			// 图例数据
			lengend: [],
			// 默认进来多个折线图的总数据
			smallLineData: [],
			// 表格数据
			bigTableData: [],
			bigTableShowData: [], // table根据分页显示的数据
			bigTableName: '',
			isShowBig: false, // 页面显示的是否是图表放大状态
			bigIndex: 0, // 页面放大状态显示的弟几个
			bigIsEmpty: false, // 放大状态是否为空
			rightPageNum: 1,
			url: {
				lineChart: '/napi/index/areaEnvStatisticsChart',
			},
			pickerOptions0: {
				disabledDate: (time) => {
					// if (this.queryParam.endTime != "") {
					//   let num = new Date(this.queryParam.endTime).getTime();
					//   let preMonthDay = new Date(
					//     GetPreMonthDay(getFormatDate(this.queryParam.endTime), 6)
					//   ); //6个月之前的日期
					//   if (time.getTime() < preMonthDay.getTime()) {
					//     return true;
					//   } else {
					//     return time.getTime() > num;
					//   }
					// } else {
					// }
					if (this.queryParam.endTime) {
						if (this.queryParam.endTime != '') {
							let num = new Date(this.queryParam.endTime).getTime()
							return time.getTime() > num
						} else {
						}
					} else {
						return false
					}
				},
			},
			pickerOptions1: {
				disabledDate: (time) => {
					// let num = new Date(this.queryParam.startTime).getTime() - 86400000;
					// let preMonthDay = new Date(
					//   GetNextMonthDay(getFormatDate(this.queryParam.startTime), 6)
					// ); //6个月之后的日期
					// if (time.getTime() > preMonthDay.getTime()) {
					//   return true;
					// } else {
					//   return time.getTime() < num;
					// }
					// let num = new Date(this.queryParam.startTime).getTime() - 86400000;
					// return time.getTime() < num;
					let num = new Date().getTime()
					if (time.getTime() > num) {
						return true
					} else {
						let startNum =
							new Date(this.queryParam.startTime).getTime() - 43200000
						if (time.getTime() < startNum) {
							return true
						} else {
							return false
						}
					}
				},
			},
			orgName: '',

			allChartData: {}, // 用于导出的全部图表原始数据
			oneChartData: {}, // 用于导出的单个列表项原始数据
		}
	},
	computed: {
		isShowAllSelect() {
			let userOrg = this.getItem('wlwOrg') || {}
			let userOrgs = JSON.parse(userOrg)
			if (userOrgs.orgLevel == 2) {
				return true
			}
			return false
		},
	},
	mounted() {
		this.$set(this.queryParam, 'startTime', this.getNowDate() + ' 00:00:00')
		this.$set(this.queryParam, 'endTime', this.getNowDate() + ' 23:59:59')
		// 选择生产区域
		if (this.isShowAllSelect) {
			// 获取上面的生产区域信息
			this.getAllOrgids()
		} else {
			this.getOrgids()
		}
	},
	methods: {
		getOrgids(isFen = false, isReauestLine = true) {
			let userInfo = this.getItem('wlwUserInfo') || {}
			let userInfos = JSON.parse(userInfo)
			let params = {
				parentOrgId: '',
				type: '3',
			}
			if (isFen) {
				params.parentOrgId = this.allOrgId
			} else {
				params.parentOrgId = userInfos.orgId
			}
			console.log(params)
			this.$http
				.getAction(this.$api.findChildOrgByParentOrgId, params)
				.then((res) => {
					console.log(res)
					if (res.meta.success) {
						let datas = res.data || []
						this.orgSelect = datas || []
						if (datas && datas.length) {
							this.$set(this.queryParam, 'orgId', datas[0]['orgId'])
							this.orgName = datas[0]['orgName']
							// 获取页面上相关的其它数据
							setTimeout(() => {
								// 获取环境监测下拉选数据
								this.getEnverSelect(isReauestLine)
							}, 300)
						} else {
							this.$set(this.queryParam, 'orgId', '')
							// 传感器恢复默认值
							this.codeSelect = []

							this.codeIsWarn = false
							this.$set(this.queryParam, 'sensorCode', '')
							this.loading = false
						}
					} else {
						this.orgSelect = []
						this.loading = false
					}
				})
				.catch(() => {
					this.orgSelect = []
					this.loading = false
				})
		},
		getAllOrgids() {
			let userInfo = this.getItem('wlwUserInfo') || {}
			let userOrg = this.getItem('wlwOrg') || {}
			let userOrgs = JSON.parse(userOrg)
			let userInfos = JSON.parse(userInfo)
			let params = {
				parentOrgId: userInfos.orgId,
				type: '2',
			}
			this.$http
				.getAction(this.$api.findChildOrgByParentOrgId, params)
				.then((res) => {
					console.log(res)
					if (res.meta.success) {
						let datas = res.data || []
						this.orgAllSelect = datas || []
						if (datas && datas.length) {
							this.allOrgId = datas[0]['orgId']
							this.getOrgids(true)
						} else {
							this.orgAllSelect = []
							this.orgSelect = []
							this.loading = false
						}
					} else {
						this.orgAllSelect = []
						this.orgSelect = []
						this.loading = false
					}
				})
				.catch(() => {
					this.orgAllSelect = []
					this.orgSelect = []
					this.loading = false
				})
		},
		// 分公司网点下拉选选择
		changeAllOrg(val) {
			this.allOrgId = val
			console.log(val)
			this.getOrgids(true, false)
		},
		// 大鹏/区域的选择
		changeOrg(val) {
			let orgIndex = this.orgSelect.findIndex((item) => {
				return item.orgId == val
			})
			this.orgName = this.orgSelect[orgIndex]['orgName']
			// 获取环境监测下拉选数据
			this.getEnverSelect(false)
		},
		// 获取环境监测下拉选数据
		getEnverSelect(isrequest = true) {
			let params = {
				orgId: this.queryParam.orgId,
			}
			this.$http
				.getAction(this.$api.findDeviceByOrgId, params)
				.then((res) => {
					if (res.meta.success) {
						let datas = res.data || []
						this.codeSelect = datas || []

						if (datas && datas.length) {
							this.$set(
								this.queryParam,
								'sensorCode',
								datas[0]['serialNumber']
							)
							if (isrequest) {
								this.loading = true
								this.$nextTick(() => {
									this.getAllLineChart()
								})
							}
						} else {
							this.$set(this.queryParam, 'sensorCode', '')
							this.loading = false
						}
					} else {
						this.$set(this.queryParam, 'sensorCode', '')
						this.codeSelect = []
						this.loading = false
					}
				})
				.catch(() => {
					this.$set(this.queryParam, 'sensorCode', '')
					this.codeSelect = []
					this.loading = false
				})
		},
		// 查询按钮点击
		onSubmit() {
			this.$refs['ruleform'].validate((valid) => {
				if (valid) {
					if (!this.codeSelect.length) {
						this.$message('暂无设备', 'warning')
						this.loading = false
						return false
					}
					if (!this.queryParam.sensorCode || this.queryParam.sensorCode == '') {
						this.$message('请选择设备', 'warning')
						this.loading = false
						return false
					}
					let miao = this.queryParam.startTime.split(' ')[1] || '00:00:00'
					let preMonthDay = new Date(
						GetNextMonthDay(getFormatDate(this.queryParam.startTime), 6) +
							' ' +
							miao
					) //6个月之后的日期
					let startTimeCuo = new Date(this.queryParam.endTime).getTime()
					if (startTimeCuo >= preMonthDay.getTime()) {
						this.$message('选择时间跨度范围不允许超过6个月', 'warning')
						this.loading = false
						return false
					}
					this.loading = true
					if (this.tabIndex == 0) {
						// 获取全部折线图数据
						this.getAllLineChart()
					} else {
						this.$nextTick(() => {
							let params = JSON.parse(JSON.stringify(this.queryParam))
							if (!this.queryParam.orgId || this.queryParam.orgId == '') {
								// 如果是分公司，没有值的情况下赋值上一级的网点
								if (this.isShowAllSelect) {
									let orgIndex = this.orgAllSelect.findIndex((item) => {
										return item.orgId == this.allOrgId
									})
									if (orgIndex > -1) {
										this.$set(
											params,
											'orgId',
											this.orgAllSelect[orgIndex]['orgId']
										)
									} else {
										this.$set(params, 'orgId', '')
									}
								}
							}
							this.$refs.bigTableModal.set(params)
							this.$refs.bigTableModal.loadData(1)
						})
					}
				} else {
					console.log('error submit!!')
					return false
				}
			})
		},
		// 获取全部折线图数据
		getAllLineChart() {
			const _this = this

			let params = JSON.parse(JSON.stringify(this.queryParam))
			if (!this.queryParam.orgId || this.queryParam.orgId == '') {
				// 如果是分公司，没有值的情况下赋值上一级的网点
				if (this.isShowAllSelect) {
					let orgIndex = this.orgAllSelect.findIndex((item) => {
						return item.orgId == this.allOrgId
					})
					if (orgIndex > -1) {
						this.$set(params, 'orgId', this.orgAllSelect[orgIndex]['orgId'])
					} else {
						this.$set(params, 'orgId', '')
					}
				}
			}

			this.$http
				.postAction(this.url.lineChart, params)
				.then(
					(res) => {
						if (res.meta.success) {
							let datas = res.data || {}
							this.allChartData = datas || {}
							// 图例数据
							let lengends = []
							let lineDatas = []
							if (datas && JSON.stringify(datas) != '{}') {
								// 图例数据调整
								Object.keys(datas).forEach((keys) => {
									lengends.push(datas[keys]['acquisitionItemName'])
									lineDatas.push(datas[keys])
								})
								this.bigIsEmpty = false
								this.lengend = lengends
								this.smallLineData = lineDatas

								// 绘制大图
								if (this.isShowBig) {
									let datas = this.smallLineData[this.bigIndex]
									this.bigTableName = `${datas.acquisitionItemName}(${datas.unit})`
									let bigTableData = []
									datas.acquisitionTimes.forEach((item, index) => {
										let aTableData = {
											times: item,
											values: datas.values[index],
										}
										bigTableData.push(aTableData)
									})
									this.bigTableData = bigTableData.reverse()
									if (bigTableData && bigTableData.length) {
										this.bigIsEmpty = false
										// 设置拆分表格上显示的数据
										this.handleCurrentChange(1)
										// 设置调整数据
										this.$nextTick(() => {
											this.makeBigLine(datas, this.bigIndex)
										})
									} else {
										this.bigIsEmpty = true
									}
								}
							} else {
								this.lengend = []
								this.smallLineData = []
								this.bigIsEmpty = true
							}
						} else {
							this.lengend = []
							this.smallLineData = []
							this.bigIsEmpty = true
						}
					},
					(error) => {
						this.lengend = []
						this.smallLineData = []
					}
				)
				.finally((err) => {
					setTimeout(() => {
						this.loading = false
					}, 500)
				})
		},
		// tab切换
		changeTab(ind) {
			if (this.tabIndex == ind) return
			this.tabIndex = ind
			if (!this.codeSelect.length) {
				if (ind == 1) {
					this.$nextTick(() => {
						this.$refs.bigTableModal.hideLoad()
					})
				}
				if (ind == 0) {
					this.lengend = []
					this.smallLineData = []
				}
				return this.$message('暂无设备', 'warning')
			}
			if (!this.queryParam.sensorCode || this.queryParam.sensorCode == '') {
				if (ind == 1) {
					this.$nextTick(() => {
						this.$refs.bigTableModal.hideLoad()
					})
				}
				return this.$message('请选择设备', 'warning')
			}
			this.loading = true
			if (ind == 1) {
				let params = JSON.parse(JSON.stringify(this.queryParam))
				if (!this.queryParam.orgId || this.queryParam.orgId == '') {
					// 如果是分公司，没有值的情况下赋值上一级的网点
					if (this.isShowAllSelect) {
						let orgIndex = this.orgAllSelect.findIndex((item) => {
							return item.orgId == this.allOrgId
						})
						if (orgIndex > -1) {
							this.$set(
								params,
								'orgId',
								this.orgAllSelect[orgIndex]['orgId']
							)
						} else {
							this.$set(params, 'orgId', '')
						}
					}
				}
				this.$nextTick(() => {
					this.$refs.bigTableModal.set(params)
					this.$refs.bigTableModal.loadData(1)
				})
			} else {
				this.lengend = []
				this.smallLineData = []
				// 重新请求折线图数据
				// 获取全部折线图数据
				this.$nextTick(() => {
					this.getAllLineChart()
				})
			}
		},
		// 综合和单个数据的切换，放大缩小的点击事件
		changeWrap(type, index) {
			if (type == this.isShowBig) return
			this.bigIndex = index
			this.isShowBig = type
			// 显示单个的，获取数据，绘制折线图
			if (this.isShowBig) {
				let datas = this.smallLineData[index]
				this.bigTableName = `${datas.acquisitionItemName}(${datas.unit})`
				let bigTableData = []
				datas.acquisitionTimes.forEach((item, index) => {
					let aTableData = {
						times: item,
						values: datas.values[index],
					}
					bigTableData.push(aTableData)
				})
				this.bigTableData = bigTableData.reverse()
				// 设置拆分表格上显示的数据
				this.handleCurrentChange(1)
				// 设置调整数据
				this.$nextTick(() => {
					this.makeBigLine(datas, index)
				})
			} else {
				// 返回多个的（防止此时的入参改变，再次请求数据保持对应）
				if (!this.codeSelect.length) {
					this.lengend = []
					this.smallLineData = []
					return this.$message('暂无设备', 'warning')
				}
				if (!this.queryParam.sensorCode || this.queryParam.sensorCode == '') {
					return this.$message('请选择设备', 'warning')
				}
				this.loading = true
				this.lengend = []
				this.smallLineData = []
				// 重新请求折线图数据
				// 获取全部折线图数据
				this.$nextTick(() => {
					this.getAllLineChart()
				})
			}
		},
		// 单个大的折线统计图
		makeBigLine(datas, index) {
			const _this = this
			let xData = datas.acquisitionTimes
			let yData = datas.values
			let myChart = this.$echarts.init(this.$refs.bigChart)
			let areaColors = this.convertHexToRGB(this.lengendColors[index], 0.26)
			let colors = this.lengendColors[index]
			let option = {
				title: {
					text: datas.acquisitionItemName,
					textStyle: {
						color: '#454545',
						fontSize: 18,
						fontWeight: 'normal',
					},
					right: '20%',
					top: 30,
				},
				tooltip: {
					show: true,
					trigger: 'axis',
					backgroundColor: '#fff',
					padding: [14, 17],
					axisPointer: {
						type: 'line',
						lineStyle: {
							color: colors,
							type: 'solid',
							width: 2,
						},
					},
					extraCssText:
						'box-shadow: 0px 0px 12px 0px rgba(76, 216, 179, 0.33);text-align:left;font-size:14px;color:#3F3F3F;letter-spacing: 1px;',
					formatter: function (param) {
						let infos = ''
						infos += `<div style="text-align:left;">${datas.acquisitionItemName}：<span style="color:${colors}">${param[0].value}${datas.unit}</span></div><div style="margin-top:12px">${param[0].name}</div`
						return infos
					},
				},
				color: this.lengendColors[index],
				grid: {
					left: '8%',
					bottom: '10%',
					top: '12%',
					right: '3%',
				},
				xAxis: {
					type: 'category',
					data: xData,
					// 刻度线
					axisTick: {
						show: false,
					},
					axisLine: {
						lineStyle: {
							color: '#EDEDED',
							width: 2,
						},
					},
					axisLabel: {
						color: '#6B6B6B',
						fontSize: 14,
						lineHeight: 30,
					},
					boundaryGap: false,
				},
				yAxis: {
					type: 'value',
					name: '(' + datas.unit + ')',
					nameTextStyle: {
						color: '#6B6B6B',
						fontSize: 14,
						align: 'right',
					},
					axisLabel: {
						color: '#6B6B6B',
						fontSize: 14,
					},
					axisLine: {
						show: true,
						lineStyle: {
							color: '#EDEDED',
							width: 2,
						},
					},
				},
				series: [
					{
						type: 'line',
						smooth: true,
						showSymbol: false,
						symbolSize: 10,
						itemStyle: {
							borderColor: this.lengendColors[index],
							borderWidth: 8,
						},
						areaStyle: {
							color: areaColors,
						},
						lineStyle: {
							width: 4,
						},
						markPoint: {
							symbolSize: 65,
							label: {
								color: '#fff',
								fontSize: 12,
							},
							data: [
								{
									type: 'max',
									name: '最大值',
									itemStyle: {
										color: '#FF648C',
									},
									z: 1,
								},
								{
									type: 'min',
									name: '最小值',
									itemStyle: {
										color: '#3EA2EF',
									},
									z: 2,
								},
							],
						},
						markLine: {
							data: [
								{
									type: 'average',
									name: '平均值',
									lineStyle: {
										type: 'solid',
										color: '#FFA800',
									},
									label: {
										position: 'middle',
										formatter: '平均值:{c}',
										color: '#FFA800',
										distance: 10,
										fontSize: 16,
									},
									symbol: 'none',
								},
							],
						},
						data: yData,
					},
				],
			}
			myChart.clear()
			myChart.setOption(option)
			window.addEventListener('resize', function () {
				myChart.resize()
			})
		},
		// 页码变化
		handleCurrentChange(val) {
			this.rightPageNum = val
			// 数据进行截取
			let showData = this.bigTableData.slice((val - 1) * 10, val * 10)
			this.bigTableShowData = showData
		},
		// 导出按钮点击
		exportDownLoad() {
			const _this = this

			// 显示的是单个的数据
			if (this.isShowBig) {
				let datas = this.smallLineData[this.bigIndex]

				let tableData = []
				let fileHead = ['序号', '创建时间']
				let filterVal = ['index', 'time']

				if (
					datas.acquisitionItemName == 'PH' ||
					datas.acquisitionItemName == 'ph'
				) {
					fileHead.push(`${datas.acquisitionItemName}`)
				} else {
					fileHead.push(`${datas.acquisitionItemName}(${datas.unit})`)
				}
				filterVal.push(datas.acquisitionItem)

				let timeArr = datas.acquisitionTimes
				let values = datas['values']
				// timeArr.sort(function (a, b) {
				// 	return b < a ? 1 : -1
				// })
				timeArr.reverse()
				values.reverse()
				timeArr.forEach((item, index) => {
					tableData.push({
						index: index + 1,
						time: item,
						[datas.acquisitionItem]: values[index],
					})
				})
				let nameIndex = this.codeSelect.findIndex((item) => {
					return item.serialNumber == this.queryParam.sensorCode
				})
				this.$nextTick(() => {
					this.handleExportXls(
						tableData,
						fileHead,
						filterVal,
						this.codeSelect[nameIndex]['deviceName'] +
							'-' +
							datas.acquisitionItemName
					)
				})
			} else {
				// 导出的是全部数据
				if (!this.allChartData || JSON.stringify(this.allChartData) == '{}') {
					this.$message('暂无导出数据', 'error')
					return
				}
				// 数据处理
				let tableData = []
				let fileHead = ['序号', '创建时间']
				let filterVal = ['index', 'time']
				let times = []

				let chartData = this.allChartData
				Object.keys(chartData).forEach((keys) => {
					if (
						chartData[keys].acquisitionItemName == 'PH' ||
						chartData[keys].acquisitionItemName == 'ph'
					) {
						fileHead.push(`${chartData[keys].acquisitionItemName}`)
					} else {
						fileHead.push(
							`${chartData[keys].acquisitionItemName}(${chartData[keys].unit})`
						)
					}
					filterVal.push(keys)
					times = times.concat(chartData[keys]['acquisitionTimes'])
				})
				let timeArr = [...new Set(times)]
				timeArr.sort(function (a, b) {
					return b < a ? 1 : -1
				})
				timeArr.reverse()
				timeArr.forEach((item, index) => {
					tableData.push({
						index: index + 1,
						time: item,
					})
				})
				Object.keys(chartData).forEach((keys) => {
					let oneTimes = chartData[keys]['acquisitionTimes']

					oneTimes.forEach((item, index) => {
						let timeIndex = timeArr.findIndex((itemt, indexx) => {
							return itemt == item
						})
						if (timeIndex > -1) {
							tableData[timeIndex][keys] = chartData[keys]['values'][index]
						}
					})
				})
				let nameIndex = this.codeSelect.findIndex((item) => {
					return item.serialNumber == this.queryParam.sensorCode
				})
				this.$nextTick(() => {
					this.handleExportXls(
						tableData,
						fileHead,
						filterVal,
						this.codeSelect[nameIndex]['deviceName'] + '区域环境变化'
					)
				})
			}
		},
	},
}
</script>
<style lang="scss" scoped>
.environcpage {
	height: 100%;

	.warnform-inline {
		.form-inputs {
			.el-form-item {
				&:not(:last-child) {
					margin-right: 2.16vw;
				}
				&.form-item-had {
					margin-right: 1.2vw;
					.el-select {
						width: 2.5rem;
					}
				}
			}
			.form-item-area {
				margin-right: 10px !important;
			}
		}
	}
	@media screen and (max-width: 1535px) {
		.warnform-inline {
			padding: 0 0.1rem;
			.form-inputs {
				.el-form-item {
					&:not(:last-child) {
						margin-right: 2vw;
					}
					&.form-item-had {
						margin-right: 1vw;
					}
				}
				.el-select {
					width: 2.5rem;
				}
			}
		}
	}
	@media screen and (max-width: 1370px) {
		.warnform-inline {
			padding: 0 0.1rem;
			.form-inputs {
				.el-form-item {
					&:not(:last-child) {
						margin-right: 1vw;
					}
					&.form-item-had {
						margin-right: 0.5vw;
						.el-select {
							width: 2rem;
						}
					}
				}
			}
		}
	}
	// 下面的内容数据
	.content-all {
		margin-top: 0.15rem;
		// width: 20.07rem;
		width: 100%;
		// min-height: 9.19rem;
		background: #ffffff;
		border-radius: 0.19rem;
		// padding-bottom: 0.25rem;
		position: relative;

		padding-bottom: 0;

		flex: 1;
		min-height: 610px;
	}
	// 综合显示
	.all-wrap {
		text-align: left;
		height: 100%;
		.tabs {
			width: 20.09rem;
			height: 0.55rem;
			background: #f3f7f8;
			border-top-left-radius: 0.13rem;
			border-top-right-radius: 0.13rem;
			overflow: hidden;
			.tab-btn {
				width: 1.77rem;
				height: 0.55rem;
				text-align: center;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
				span {
					font-size: 0.2rem;
					color: #333333;
				}
				.tab-icon {
					width: 0.25rem;
					height: 0.25rem;
					margin-right: 0.11rem;
				}
			}
			.tab-btn-active {
				background-color: #ffffff;
			}
		}
		.bottom-empty {
			// height: 8rem;
			width: 100%;
			margin-top: 2.49rem;
		}
		// lengend图例
		.lengends {
			width: 19.56rem;
			height: 0.75rem;
			border: 1px solid #f1f1f1;
			margin: 0.24rem auto 0;
			padding: 0 0.42rem;
			.lengend-div {
				&:nth-child(n + 2) {
					margin-left: 0.68rem;
				}
			}
			.lengend-len {
				display: inline-block;
				width: 0.3rem;
				height: 0.17rem;
				border-radius: 4px;
				margin-right: 0.15rem;
				cursor: pointer;
			}
			.lengend-name {
				font-size: 0.2rem;
				color: #333;
			}
		}
		// 折线图合集
		.chart-all {
			flex: 1;
			overflow-y: scroll;
			padding-left: 0.25rem;
			padding-right: 0.25rem;
			padding-bottom: 0.2rem;
			// 背景
			&::-webkit-scrollbar {
				width: 8px;
				height: 0px;
				background-color: transparent;
				border-radius: 4px;
			}
			// 背景
			&::-webkit-scrollbar-track {
				width: 8px;
				height: 8px;
				background-color: transparent;
				border-radius: 4px;
			}
			// 滚动条
			&::-webkit-scrollbar-thumb {
				width: 8px;
				height: 8px;
				border-radius: 4px;
				background-color: #d9d9d9;
			}
			.chart-divs {
				display: inline-block;
				width: 32.5%;
				height: 45%;
				background: url('../../assets/image/analysis/chart_bg.png') no-repeat;
				background-size: 100% 100%;
				margin-top: 1%;
				margin-left: 1.2%;
				position: relative;
				&:nth-child(3n + 1) {
					margin-left: 0;
				}
				.chart-div {
					width: 100%;
					height: 98%;
				}
				.icon_setdiv {
					position: absolute;
					right: 0.38rem;
					top: 0.13rem;
					width: 0.7rem;
					height: 0.3rem;
					border: 1px solid #2daea9;
					border-radius: 4px;
					text-align: center;
					padding-top: 0.06rem;
					cursor: pointer;
					.icon_add {
						width: 0.2rem;
						height: 0.2rem;
					}
				}
			}
		}
		.chart-content {
			height: calc(100% - 0.55rem);
		}
		// table
		.table-content {
			text-align: center;
		}
	}
	// 单个显示
	.one-wrap {
		text-align: left;
		background-color: #fff;
		position: absolute;
		width: 20.07rem;
		height: 100%;
		// min-height: 9.19rem;
		top: 0;
		left: 0;
		border-radius: 0.19rem;
		padding-top: 0.4rem;
		.one-main {
			width: 19.57rem;
			height: 98%;
			background-image: url('../../assets/image/analysis/one_bg.png');
			background-size: 100% 100%;
			background-repeat: no-repeat;
			margin: auto;
			padding-right: 0.23rem;
		}
		.big-chart {
			width: 13.8rem;
			height: 100%;
		}
		.icon_setdiv {
			display: inline-block;
			width: 0.7rem;
			height: 0.3rem;
			border: 1px solid #2daea9;
			border-radius: 4px;
			text-align: center;
			padding-top: 0.06rem;
			margin-bottom: 0.2rem;
			cursor: pointer;
			.icon_add {
				width: 0.2rem;
				height: 0.2rem;
			}
		}
		.big-table {
			width: 5.28rem;
			margin-top: 0;
			padding-top: 0.2rem;
			background-color: transparent;
			.tables {
				border: 1px solid #e2e2e2;
				border-radius: 0;
			}
		}

		.pagination {
			width: 5.28rem;
			text-align: center;
			padding-top: 0.25rem;
		}
		.emptys {
			width: 19.57rem;
			height: 8.38rem;
			margin: auto;
			.bottom-empty {
				width: 100%;
				height: 7.5rem;
			}
		}
	}
}
</style>
<style lang="scss">
.one-wrap {
	.warn-tables {
		.tables {
			border: none;
			border-left: 1px solid #e2e2e2;
			border-right: 1px solid #e2e2e2;
			border-radius: 0;
			.table-cell {
				padding: 1.1vh 0;
			}
		}
	}
}
</style>
